// DashboardCounts.jsx
import React, { useEffect, useState } from "react";
import { Bars } from "react-loader-spinner";
import axiosInstance from "../../Shared/axiosInstance.js";

export default function DashboardCounts() {
  const [counts, setCounts] = useState(null);
  const [loading, setLoading] = useState(false);

  async function fetchCounts() {
    setLoading(true);
    try {
      const { data } = await axiosInstance.get("/Account/dashboard-counts");
      if (data.status === 200) setCounts(data.data);
      else throw new Error(data.message || "فشل في جلب البيانات");
    } catch (error) {
      console.error("خطأ في بيانات لوحة التحكم:", error);
    }
    setLoading(false);
  }

  useEffect(() => {
    fetchCounts();
  }, []);

  if (loading) {
    return (
      <div 
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "60px 0",
          background: "#fff",
          borderRadius: "12px",
          border: "1px solid #e2e8f0",
          marginBottom: "40px",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <Bars height="60" width="60" color="#2563eb" />
          <p style={{ color: "#64748b", marginTop: "16px", fontSize: "14px" }}>
            جاري تحميل لوحة التحكم...
          </p>
        </div>
      </div>
    );
  }

  if (!counts) return null;

  const stats = [
    { title: "المشتريات المدفوعة", count: counts.paidPurchases, color: "#10b981", icon: "bi-check-circle-fill", desc: "مكتملة" },
    { title: "المشتريات المدفوعة جزئيًا", count: counts.partiallyPaidPurchases, color: "#f59e0b", icon: "bi-hourglass-split", desc: "قيد التنفيذ" },
    { title: "المبيعات المدفوعة", count: counts.paidSales, color: "#14b8a6", icon: "bi-check-circle-fill", desc: "مكتملة" },
    { title: "المبيعات المدفوعة جزئيًا", count: counts.partiallyPaidSales, color: "#f97316", icon: "bi-hourglass-split", desc: "قيد التنفيذ" },
    { title: "إجمالي العملاء", count: counts.totalCustomers, color: "#3b82f6", icon: "bi-people-fill", desc: "نشط" },
    { title: "إجمالي الموردين", count: counts.totalSuppliers, color: "#6366f1", icon: "bi-truck", desc: "نشط" },
    { title: "إجمالي المنتجات", count: counts.totalProducts, color: "#2563eb", icon: "bi-box-seam-fill", desc: "متوفر بالمخزون" },
    { title: "إجمالي الأقسام", count: counts.totalCategories, color: "#8b5cf6", icon: "bi-folder-fill", desc: "منظم" },
    { title: "إجمالي الماركات", count: counts.totalBrands, color: "#06b6d4", icon: "bi-tag-fill", desc: "متوفر" },
  ];

  return (
<div className="pt-5">
      <div className="container py-5 mt-5" style={{ maxWidth: "1400px" }}>
      {/* Section Header */}
      <div className="d-flex align-items-center mb-4" style={{ borderLeft: "4px solid #f59e0b", paddingLeft: "16px" }}>
        <div>
          <h2 style={{ color: "#d97706", fontSize: "28px", fontWeight: "700", marginBottom: "4px" }}>
            نظرة عامة على لوحة التحكم
          </h2>
          <p style={{ color: "#64748b", fontSize: "14px", marginBottom: 0 }}>
            إحصائيات وبيانات في الوقت الحقيقي
          </p>
        </div>
      </div>

      {/* Stats Grid */}
      <div className="row g-4">
        {stats.map((stat, idx) => (
          <div className="col-lg-4 col-md-6 col-sm-6" key={idx}>
            <div
              style={{
                background: "#fff",
                border: "1px solid #e2e8f0",
                borderRadius: "12px",
                padding: "24px",
                height: "100%",
                transition: "all 0.3s ease",
                cursor: "default",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
                position: "relative",
                overflow: "hidden",
              }}
            >
              {/* Background Icon */}
              <div style={{ position: "absolute", top: "-10px", right: "-10px", fontSize: "80px", color: `${stat.color}08`, transform: "rotate(-15deg)" }}>
                <i className={stat.icon}></i>
              </div>

              {/* Content */}
              <div style={{ position: "relative", zIndex: 1 }}>
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <div style={{ width: "48px", height: "48px", borderRadius: "10px", background: `${stat.color}15`, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <i className={stat.icon} style={{ fontSize: "24px", color: stat.color }}></i>
                  </div>
                  <span style={{ fontSize: "36px", fontWeight: "700", color: stat.color, lineHeight: 1 }}>
                    {stat.count}
                  </span>
                </div>
                <h6 style={{ color: "#1e293b", fontSize: "19px", fontWeight: "600", marginBottom: "4px" }}>{stat.title}</h6>
                <p style={{ color: "#64748b", fontSize: "15px", marginBottom: 0 }}>
                  <i className="bi bi-dot" style={{ fontSize: "20px", verticalAlign: "middle" }}></i>
                  {stat.desc}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
</div>
  );
}
